/* eslint-disable */
<template>
  <div class="specialists">
    <AdminNavigation ref="navigation" indexProps="3"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Specialists</h1></div>
        <div class="header-sub-title"><span class="search-title" v-html="searchTitle"></span></div>
      </div>
    </div>
    <div class="panel">
      <AdminSpecialistMenu :key="specialistMenuIndex" :indexProps="specialistMenuIndex"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col-1">
            <div class="w-50">
              <img
                  class="is-icon div-image"
                  src="@/assets/images/file_icon.svg"
                  data-placement="right"
                  data-toggle="tooltip"
                  title="Download PDF"
                  :disabled="selectedSpecialists.length == 0"
                  :class="selectedSpecialists.length == 0 ? 'disabled-element' : ''"
                  @click="selectedSpecialists.length == 0 ? '' : downloadPdf()"
              />
            </div>
          </div>
          <div class="col">
            <div class="icon-group right-float-element">
              <div class="d-inherit">
                <img v-if="!useSearch" src="@/assets/images/search_black_icon.svg" title="Search Specialist"
                     @click="openSearchSpecialist"/>
                <img v-else src="@/assets/images/close_icon.svg" @click="cancelSearch" title="Cancel Search"/>
                <el-input @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
              </div>
              <router-link :to="{ name: 'admin-manage-specialist', query: {} }">
                <v-btn class="add-icon" dark>Add New</v-btn>
              </router-link>
            </div>
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <el-table @row-click="openSpecialist" :default-sort="{prop: 'SpecialistName', order: 'descending'}"
                      :data="specialists" stripe @sort-change="sortParam" tooltip-effect="dark"
                      :header-row-style="{background: '#fde9eb', height: '70px'}"
                      :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="80"
                  show-overflow-tooltip
                  label="ID"
                  prop="SpecialistID"
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Name"
                  sortable="custom"
                  prop="SpecialistName"
              >
                <template slot-scope="scope">
                  <span>{{ getSpecialistFullName(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label=" "
                  prop="SpecialistID"
              >
                <template slot-scope="scope">
                  <img
                      :src="scope.row.ByRequestOnly ? require('@/assets/images/by_request_only_icon.svg') : require('@/assets/images/by_request_only_dark_icon.svg')"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="scope.row.ByRequestOnly ? 'By Request Only' : 'Not By Request Only'"
                  />
                </template>
              </el-table-column>
              <el-table-column
                  width="160"
                  show-overflow-tooltip
                  label="Client Alignment"
                  prop="ClientAlignment"
              >
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Certifications"
                  prop="Certifications"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.Certifications.map(item => item.CertificationName).join(', ') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label="Specialities"
                  prop="Specialities"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.Qualifications.map(item => item.QualificationName).join(', ') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Next Availability"
                  prop="NextAvailabilityDate"
              >
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.NextAvailabilityDate, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Last Availability"
                  prop="LastAvailabilityDate"
              >
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.LastAvailabilityDate, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  label=" "
                  prop="ClientAlignment"
              >
                <template slot-scope="scope">
                  <div class="icon-group" >
                    <router-link :to="{ name: 'admin-specialist-bookings', query: { id: scope.row.SpecialistID } }"
                    ><img src="@/assets/images/calendar_dark_grey_icon.svg" data-placement="right"
                          data-toggle="tooltip" title="View Bookings"
                    /></router-link>
                    <router-link
                        :to="{ name: 'admin-search-specialist', query: { specialistId: scope.row.SpecialistID } }"
                    ><img src="@/assets/images/add_booking_dark_icon.svg" data-placement="right" data-toggle="tooltip"
                          title="Add Booking"
                    /></router-link>
                    <a @click.stop="" :href="scope.row.ZohoLink" target="_blank"><img src="@/assets/images/zoho_icon.svg"
                                                                        data-placement="right" data-toggle="tooltip"
                                                                        title="Link to Zoho"/></a>
                    <EditZohoLinkDialog @showEdit="showEdit" @updateSuccess="updateSuccess" :id="scope.row.SpecialistID" :index="scope.$index" type="specialist"/>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSpecialistMenu from '@/components/AdminSpecialistMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash'
import EditZohoLinkDialog from '../components/dialog/EditZohoLinkDialog.vue'


export default {
  name: 'AdminSpecialists',
  props: ['searchOptionProps'],
  components: {
    AdminNavigation,
    AdminSpecialistMenu,
    Header,
    EditZohoLinkDialog
  },
  data() {
    return {
      isEditing: false,
      dialogVisible: false,
      fetchedData: false,
      specialists: [],
      allSpecialists: [],
      selectedSpecialists: [],
      limit: 20,
      pagination: utilities.initPagination(),
      specialistMenuIndex: 0,
      searchTitle: "",
      nextMaxDate: "",
      lastMaxDate: "",
      searchParam: {},
      // ASC (true) with down icon (false), DESC (false) with up icon (true)
      byName: false,
      byNextAvailability: false,
      byLastAvailability: false,
      fromSearch: false,
      useSearch: false,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'SpecialistName',
        ascOrDesc: 'DESC'
      },
      totalCount: 0,
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    showEdit(v) {
      this.isEditing = v
    },
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    getSpecialistFullName(specialist) {
      return utilities.getSpecialistFullNameUpper(specialist)
    },
    search: debounce(function () {
      this.searchParam.name = this.listParam.SpecialistName
      this.searchSpecialist(this.searchParam)
    }, 800),
    cancelSearch() {
      this.useSearch = false
      this.listParam = {
        pageSize: 10,
        pageNum: 1,
        orderBy: 1
      }
      this.searchParam = {}
      this.showSearchTitle('')
      this.loadSpecialists()
    },
    updateSuccess(index, newLink) {
      let obj = _.cloneDeep(this.specialists[index])
      obj.zohoLink = newLink
      this.$set(this.specialists, index, obj)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadSpecialists()
    },

    formatDate(dateToFormat, newFormat) {
      if (!dateToFormat) return ''
      return window.moment(dateToFormat).format(newFormat)
    },
    changeCheckboxAll(e) {
      if (e.target.checked) {
        $('.form-checkbox').prop('checked', true)
        this.selectedSpecialists = this.specialists.map((x) => x.id)
      } else {
        $('.form-checkbox').prop('checked', false)
        this.selectedSpecialists = []
      }
    },
    changeCheckbox(e) {
      if (e.target.checked) {
        // Add to list
        this.selectedSpecialists.push(this.specialists[e.target.value].id)
      } else {
        // Remove from list
        this.selectedSpecialists = this.selectedSpecialists.filter((x) => x != this.specialists[e.target.value].id)
      }
      var checkedNumber = $('.form-checkbox:checked').length

      if (checkedNumber == 0) {
        $('.form-checkbox-all').prop('checked', false)
      }
      if (checkedNumber >= $('.form-checkbox').length - 1) {
        $('.form-checkbox-all').prop('checked', true)
      }
    },
    openSearchSpecialist() {
      this.$refs.navigation.$refs.globalSearch.openSearchSpecialist()
    },
    openSpecialist({SpecialistID}) {
      if(this.isEditing) return
      if (this.fromSearch) {
        let routeData = this.$router.resolve({name: 'admin-manage-specialist', query: {id: SpecialistID}});
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({name: 'admin-manage-specialist', query: {id: SpecialistID}})
      }
    },
    paging() {
      utilities.disposeTooltip()
      utilities.initTooltip()
      utilities.hoverTooltip()
    },
    showSearchTitle(text) {
      this.searchTitle = text
    },
    async downloadPdf() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      var specialistIds = this.selectedSpecialists.join(',')
      var pdf = await utilities.getSpecialistProfilesByIds(specialistIds)
      var a = document.createElement('a')
      let blob = pdf
      a.setAttribute('href', window.URL.createObjectURL(blob))
      a.setAttribute('download', 'SpecialistsProfile.pdf')
      a.click()
      await this.$store.dispatch('loading/setLoadComponent', false)
    },

    async searchSpecialist(searchOption) {
      this.fromSearch = true
      var params = {
        QualificationID: searchOption.qualificationTags ? searchOption.qualificationTags.map((x) => x.value).join(', ') : null,
        PersonConditionID: searchOption.personConditionTags ? searchOption.personConditionTags.map((x) => x.value).join(', ') : null,
        SpecialistName: searchOption.name,
      }

      if (searchOption.regionId != null) {
        if (searchOption.regionId.includes('r')) {
          params.RegionID = searchOption.regionId.replace('r', '')
        } else {
          params.CityID = searchOption.regionId.replace('c', '')
          if (searchOption.radius > 0) params.Radius = searchOption.radius
        }
      }
      params.pageNum = 1
      params.pageSize = 10
      this.listParam = params
      await this.$store.dispatch('loading/setLoadComponent', true)
      var {specialists, total} = await utilities.getSearchSpecialists(this.listParam)
      await this.$store.dispatch('loading/setLoadComponent', false)
      this.useSearch = true
      this.specialists = _.cloneDeep(specialists)
      this.totalCount = total

      var text = '<b>Search:</b>'
      if (searchOption.qualificationTags && searchOption.qualificationTags.length > 0) {
        text += '&nbsp;&nbsp;&nbsp;<b>Qualified to Practice As:</b> ' + searchOption.qualificationTags.map((x) => x.text).join(', ')
        text += '.'
      }
      if (searchOption.personConditionTags && searchOption.personConditionTags.length > 0) {
        text += '&nbsp;&nbsp;&nbsp;<b>Expert In:</b> ' + searchOption.personConditionTags.map((x) => x.text).join(', ')
        text += '.'
      }
      if (searchOption.name !== '') {
        text += '&nbsp;&nbsp;&nbsp;<b>Name:</b> ' + searchOption.name
        text += '.'
      }
      if (searchOption.regionId != null && searchOption.regionId != '') {
        text += '&nbsp;&nbsp;&nbsp;<b>Location:</b> ' + searchOption.regionName
        if (searchOption.regionId.includes('c') && searchOption.radius > 0) text += ' (within ' + searchOption.radius + ' km)'
        text += '.'
      }
      this.showSearchTitle(text)
      this.searchParam = searchOption
    },
    async loadSpecialists() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const {specialists, total} = await utilities.getSpecialistsNew(this.listParam)
      this.specialists = specialists
      this.totalCount = total
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  async beforeMount() {
    if (this.searchOptionProps !== undefined) {
      await this.searchSpecialist(this.searchOptionProps)
    } else {
      await this.loadSpecialists()
    }
    this.fetchedData = true
  },
  mounted() {
    $('.pagination').hide()
  },
}
</script>
